import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist({
  key: "Yvooa-Core",
  storage: sessionStorage,
});

export const navigatedNotif = atom({
  key: "navigatedNotif",
  default: {},
  effects_UNSTABLE: [persistAtom],
});

export const navigatedNotifIndex = atom({
  key: "navigatedNotifIndex",
  default: "",
  effects_UNSTABLE: [persistAtom],
});

export const navHistory = atom({
  key: "navHistory",
  default: {
    sourceUrl: "",
    sourceActiveTab: "",
    activeTab: "",
  },
  effects_UNSTABLE: [persistAtom],
});

export const portfolioTableActiveTab = atom({
  key: "portfolioTableActiveTab",
  default: "properties",
  effects_UNSTABLE: [persistAtom],
});

export const propertyDetailsActiveTab = atom({
  key: "propertyDetailsActiveTab",
  default: "home",
  effects_UNSTABLE: [persistAtom],
});

export const unitDetailsActiveTab = atom({
  key: "unitDetailsActiveTab",
  default: "home",
  effects_UNSTABLE: [persistAtom],
});

export const navigationLayoutMode = atom({
  key: "navigationLayoutMode",
  default: "horizontal",
  effects_UNSTABLE: [persistAtom],
});

// Delinquency Report: persist active tab selection
export const delinquencyActiveTabAtom = atom({
  key: "delinquencyActiveTabAtom",
  default: "current",
  effects_UNSTABLE: [persistAtom],
});

export const delinquencyFiltersAtom = atom({
  key: "delinquencyFiltersAtom",
  default: {
    portfolio: null,
    property: null,
  },
  effects_UNSTABLE: [persistAtom],
});

// Shared navbar notifications — persisted across sidebar/horizontal transitions in the same session
export const navbarNotificationsAtom = atom({
  key: "navbarNotificationsAtom",
  default: [],
  effects_UNSTABLE: [persistAtom],
});
